import { useState, useEffect, useCallback } from "react";
import dayjs from 'dayjs';

import "./style.css";
import {
  PieChartOutlined,
  UserOutlined,
  ClearOutlined,
  FilterOutlined,
} from "@ant-design/icons";

import { Layout, Menu, Input, DatePicker, Select, Modal, Checkbox, Tooltip } from "antd";
import { CircularProgress } from "@mui/material";
import { Method_POST } from "../../../service/api";
import DoughnutChart from "./Grafico";
import PortalContadorOS from "../Modal/OrdensDeServiço/PortalContadorOS";
import ExportExcel from "./ExportExcel";
import DoughnutBar from "./Grafico/PorEstado";

import TabelaOrdensServico from "./TabelaordensServico";
import ResultCards from "./ResultCards";
import ModalObservacao from "./TabelaordensServico/Modais/ModalObservacao";
import { Option } from "antd/es/mentions";
import { MdNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
const { Header, Content, Footer, Sider } = Layout;

const { RangePicker } = DatePicker;

const ITEMS_PER_PAGE = 15;

export function DashboardOrdemServico() {
  const [collapsed, setCollapsed] = useState(false);
  //const {token: { borderRadiusLG }} = theme.useToken();

  const [ordensServicoOriginais, setOrdensServicoOriginais] = useState([]);
  const [ordensServico, setOrdensServico] = useState([]);
  
  const [searchAnalista, setSearchAnalista] = useState('');
  const [page, setPage] = useState(1);
  //const itemsPerPage = 10;


  // Estados relacionados à paginação e carregamento
  const [paginaAtual, setPaginaAtual] = useState(1); // Página que está sendo exibida
  const [tamanhoLote, setTamanhoLote] = useState(5000); // Quantidade de registros a carregar da API
  const [totalRegistros, setTotalRegistros] = useState(null); // Total de registros na base
  const [totalPaginas, setTotalPaginas] = useState(null); // Total de páginas

  const [canceladas, setCanceladas] = useState(0);
  const [finalizadas, setFinalizadas] = useState(0);
  const [suspenca, setSuspenca] = useState(0);
  const [ativas, setAtivas] = useState(0);
  const [total, setTotal] = useState(0);

  const [isMostrarObservacao, setIsMostrarObservacao] = useState(false);

  const [observacoesAtuais, setObservacoesAtuais] = useState({
    formatadas: [],
    naoFormatadas: [],
  });

  const [isModalPortalContadorOS, setIsModalPortalContadorOS] = useState(false);
  const [idSelecionado, setIdSelecionado] = useState(null);

  const [analistaSelecionado, setAnalistaSelecionado] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [ordemServico, setOrdemServico] = useState("");

  const [dataSituacao, setDataSituacao] = useState(null);
  const [tipoOS, setTipoOS] = useState([]);
  const [situacaoOS, setSituacaoOS] = useState([]);
  const [naoAtribuida, setNaoAtribuida] = useState(false);
  const [prazoEmDias, setPrazoEmDias] = useState()
  const [situacaoOSSuspensas, setSituacaoOSSuspensas] = useState(false);
  const [situacaoOsCanceladas, setSituacaoOsCanceladas] = useState(false);
  const [situacaoOsFinalizadaParalegal, setSituacaoOsFinalizadaParalegal] = useState(false);
  const [situacaoOsCanceladasESuspensa, setSituacaoOsCanceladasESuspensa] = useState(false);

  const [ordensAtivas, setOrdensAtivas] = useState(false);
  const [ordensAtivasParalegal, setOrdensAtivasParalegal] = useState(false);
  
  const [isExportExcel, setIsExportExcel] = useState(false);
  const [isModalOsPorEstados, setIsModalOsPorEstados] = useState(false);

  const [dataCriacaoRange, setDataCriacaoRange] = useState([]);
  const [ordensUFAtivas, setOrdensUFAtivas] = useState([]);

  const [loading, setLoading] = useState(false);
  const [filtroDias, setFiltroDias] = useState("todos");

  const [listAnalista, setListAnalista] = useState([]);

  const [nomeAnalista, setNomeAnalista] = useState([]);
  const [mudarNome, setMudarNome] = useState("Ativas")
  const [perfilNome, setPerfilNome] = useState("TODOS"); // valor inicial

  // ---- Modal ----
  const [modalVisible, setModalVisible] = useState(true);

  // ---- State para os analistas únicos ----
  const [analistasUnicos, setAnalistasUnicos] = useState([]);

  useEffect(() => {
    fetchAnalista();
  }, [])

  const fetchAnalista = async (perfilId) => {
    try {
      const url = `/ordem-servico/analista/listar`;
      const data = {
        situacao: { id: "A" },
      };

      console.log("fetchAnalista payload:", data);

      const response = await Method_POST(url, data);

      if (Array.isArray(response)) {
        setListAnalista(response);
      } else {
        setListAnalista([]);
      }
    } catch (error) {
      console.error("Erro ao buscar analistas:", error);
      setListAnalista([]);
    }
  };

  // ---- Função central para carregar ordens ----
  const carregarLote = async (quantidade, perfil) => {

    let cancelled = false;
    setLoading(true);
    setPaginaAtual(1);
    setOrdensServico([]);

    try {
      const body = {
        ordemServico: {
          contato: { nome: "" },
          tipo: { nome: perfil },
          situacao: { nome: "" },
        },
        paginacao: { pagina: 1, tamanho: quantidade },
      };

      const res = await Method_POST("/ordem-servico/pesquisar", body);

     // ---- aqui ele pega todos os analistas das OS que foram carregadas, faço um forEach 
     // para listar esses analistas e usa-los em um select para buscar de forma dinamica ----
      const analistasMap = new Map();

      res.ordensServico.forEach((ordem) => {
        const id = ordem?.usuarioAtribuicao?.id;
        if (id) {
          analistasMap.set(id, {
            idAnalista: id,
            nomeAnalista: ordem.usuarioAtribuicao?.nome || "Sem nome",
          });
        }
      });

      const listaAnalistas = Array.from(analistasMap.values());
      setAnalistasUnicos(listaAnalistas); // <-- Guardando no state
      //console.log("listaAnalistas", listaAnalistas)

      if (!cancelled && res?.ordensServico) {
        setOrdensServicoOriginais(res.ordensServico);
        setOrdensServico(res.ordensServico);

        const totalApi = res?.paginacao?.totalRegistros || res.ordensServico.length;
        setTotalRegistros(totalApi);
        setTotalPaginas(Math.ceil(totalApi / ITEMS_PER_PAGE));

      }
    } catch (err) {
      if (!cancelled) console.error("Erro ao carregar ordens:", err);
    } finally {
      if (!cancelled) setLoading(false);
    }

    return () => {
      cancelled = true;
    };
  };

  const confirmarCarregamento = () => {
    setModalVisible(false);
    carregarLote(
      tamanhoLote,
      perfilNome,
    );
  };

  const formatarObservacoes = (texto) => {
  if (!texto) return { formatadas: [], naoFormatadas: [] };

  // Match: "Observação 01 - 01/06/2024\nDescrição"
  const regex = /(Observa(?:ç|c)ão\s*\d*\s*-\s*\d{2}\/\d{2}\/\d{4})\n([^\n]+)/g;
  const matches = [...texto.matchAll(regex)];

  const formatadas = matches.map((match, index) => ({
    titulo: match[1],
    descricao: match[2],
    indexOriginal: index,
  }));

  let textoRestante = texto;
  matches.forEach((match) => {
    textoRestante = textoRestante.replace(match[0], '');
  });

  const naoFormatadas = textoRestante
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  return { formatadas, naoFormatadas };
  };

  const ultimaDataObservacao = (texto) => {
    const { formatadas } = formatarObservacoes(texto);
    const ultima = formatadas.at(-1);
    return ultima ? ultima.titulo.split(' - ')[1] : null;
  };

  const diasDesdeUltimaObservacao = (texto) => {
    const dataStr = ultimaDataObservacao(texto);
    if (!dataStr) return null;

    const hoje = dayjs();
    const dataObs = dayjs(dataStr, 'DD/MM/YYYY');
    return hoje.diff(dataObs, 'day');
  };

  // ---- Aplicar filtros ----
  useEffect(() => {
    let filtradas = ordensServicoOriginais;

    setMudarNome(
      ordensAtivasParalegal === true
        ? "Ativas Paralegal"
        : ordensAtivas === true
          ? "Ativas"
          : "Em aberto"
    );



    if (analistaSelecionado) {
      filtradas = filtradas.filter(
        (ordem) => ordem?.usuarioAtribuicao?.id === analistaSelecionado
      );
    }

    if (nomeAnalista.length > 0) {
      filtradas = filtradas.filter((ordem) =>
        nomeAnalista.includes(ordem?.usuarioAtribuicao?.id)
      );
    }

    if (idCliente) {
      filtradas = filtradas.filter(
        (ordem) => String(ordem?.cliente?.id) === String(idCliente)
      );
    }

    if(ordemServico) {
      filtradas = filtradas.filter(
        (ordem)=> String(ordem?.id) === String(ordemServico)
      )
    }

    if (dataCriacaoRange && dataCriacaoRange.length === 2) {
      filtradas = filtradas.filter((ordem) => {
        const data = dayjs(ordem.dataCriacao);
        const inicio = dayjs(dataCriacaoRange[0]);
        const fim = dayjs(dataCriacaoRange[1]);
  
        return (
          (data.isAfter(inicio) || data.isSame(inicio, 'day')) &&
          (data.isBefore(fim) || data.isSame(fim, 'day'))
        );
      });
    }
  
    if (dataSituacao) {
      filtradas = filtradas.filter((ordem) => {
        const dataSit = dayjs(ordem.dataSituacao);
        return dataSit.isSame(dayjs(dataSituacao), "day");
      });
    }

    if (Array.isArray(tipoOS) && tipoOS.length > 0) {
      filtradas = filtradas.filter((ordem) =>
        tipoOS.some(
          (sit) => ordem?.tipo?.nome?.toLowerCase() === sit.toLowerCase()
        )
      );
    }

    if (Array.isArray(situacaoOS) && situacaoOS.length > 0) {
      filtradas = filtradas.filter((ordem) =>
        situacaoOS.some(
          (sit) => ordem?.situacao?.nome?.toLowerCase() === sit.toLowerCase()
        )
      );
    }
    
    if (ordensAtivas) {
      filtradas = filtradas.filter((ordem) => ordem.situacao?.id !== "C" && ordem.fgExecucaoSuspensa !== true && ordem.situacao?.id !== "F");
    }

   if (ordensAtivasParalegal) {
      filtradas = filtradas.filter((ordem) =>
        ordem.situacao?.id !== "C" &&
        ordem.fgExecucaoSuspensa !== true &&
        ordem.situacao?.id !== "F" &&
        ordem.situacao?.id !== "F-DOC" &&
        ordem.tipo?.id !== "2" &&
        ordem.tipo?.id !== "10301" &&
        ordem.tipo?.id !== "101" &&
        ordem.tipo?.id !== "10371" &&
        ordem.tipo?.id !== "103" &&
        ordem.tipo?.id !== "10302" &&
        ordem.tipo?.id !== "102" &&
        ordem.tipo?.id !== "10372" &&
        ordem.tipo?.id !== "10306" &&
        ordem.tipo?.id !== "10303"
      )
    }

    
    if(situacaoOsCanceladas){
      filtradas = filtradas.filter((ordem) => ordem.situacao?.nome === "Cancelada" && ordem.fgExecucaoSuspensa !== true);
    }

    if(situacaoOsFinalizadaParalegal){
      filtradas = filtradas.filter((ordem) => ordem.situacao?.id === "F-DOC");
    }

    if (situacaoOSSuspensas) {
      filtradas = filtradas.filter(
        (ordem) =>
          ordem.fgExecucaoSuspensa === true &&
          ordem.situacao?.nome !== "Cancelada"
      );
    }

    if(situacaoOsCanceladasESuspensa){
      filtradas = filtradas.filter(
        (ordem) =>
          ordem.fgExecucaoSuspensa === true &&
          ordem.situacao?.nome === "Cancelada"
      );
    }

    if (naoAtribuida) {
      filtradas = filtradas.filter((ordem) => ordem.usuarioAtribuicao?.id === null);
    }

    if (filtroDias && filtroDias !== "todos") {
      filtradas = filtradas.filter((ordem) => {
        if (ordem.fgExecucaoSuspensa) return false; // suspensa, fora
        if (ordem.situacao?.id === "F") return false;
        if (ordem.situacao?.id === "C") return false;
        if (ordem.situacao?.id === "F-DOC") return false;

        const dias = diasDesdeUltimaObservacao(ordem.observacao) || 0;
        if (filtroDias === "maiorIgual4") return dias >= 4;
        if (filtroDias === "menorIgual3") return dias <= 3;
        return true;
      });


  }

    //console.log("Ordens filtradas dinamicamente:", filtradas);
    setOrdensServico(filtradas);
    setPage(1);
  }, [analistaSelecionado, nomeAnalista, idCliente, ordemServico, dataCriacaoRange, dataSituacao, tipoOS, situacaoOS, ordensAtivas, ordensAtivasParalegal, situacaoOSSuspensas, situacaoOsCanceladas, situacaoOsFinalizadaParalegal, situacaoOsCanceladasESuspensa, ordensServicoOriginais, naoAtribuida, filtroDias]);

  
  const filteredAnalistas = listAnalista.filter((analista) =>
    analista.nome.toLowerCase().includes(searchAnalista.toLowerCase())
  );

  // ---- Calcular totais para os cards ----
  useEffect(() => {
    let countCanceladas = 0;
    let countSuspensas = 0;
    let countFinalizadas = 0;
    let countAtivas = 0;
  
    const ordensPorUF = {}; //96337
  
    ordensServico.forEach(ordem => {
      if (ordem.situacao?.nome === "Cancelada") {
        countCanceladas++;
      } else if (ordem.fgExecucaoSuspensa === true) {
        countSuspensas++;
      }else if (ordem.situacao?.id === "F") {
        countFinalizadas++;
      }else {
        // Considera como ativa
        countAtivas++;
  
        // Conta por UF apenas para as ativas
        const uf = ordem?.empresa?.endereco?.uf;
        if (uf) {
          ordensPorUF[uf] = (ordensPorUF[uf] || 0) + 1;
        }
      }
    });
  
    const resultadoArray = Object.entries(ordensPorUF).map(([uf, total]) => ({
      uf,
      total
    }));
  
    //console.log("Ordens ativas por UF:", resultadoArray);
    
    setCanceladas(countCanceladas);
    setSuspenca(countSuspensas);
    setFinalizadas(countFinalizadas);
    setAtivas(countAtivas);
    setTotal(ordensServico.length);
    
    setOrdensUFAtivas(resultadoArray);
  }, [ordensServico]);

  const analistasMenuItems = filteredAnalistas.map((analista, index) => ({
    key: `analista-${analista.id}`,
    label: analista.nome,
  }));


  const limparCampos = useCallback(() => {
    setSearchAnalista("");
    setAnalistaSelecionado("");
    setIdCliente("");
    setOrdensAtivas(false);
    setOrdensAtivasParalegal(false);
    setNaoAtribuida(false)
    setDataCriacaoRange([]);
    setSituacaoOS([]);
    setTipoOS([]);
    setSituacaoOSSuspensas(false);
    setSituacaoOsCanceladas(false);
    setSituacaoOsCanceladasESuspensa(false);
    setSituacaoOsFinalizadaParalegal(false);
    setFiltroDias("");
    setOrdemServico("");
    setOrdensServico(ordensServico);
  }, [ordensServico]);

  // ---- Paginação local ----
  const indiceInicial = (paginaAtual - 1) * ITEMS_PER_PAGE;
  const indiceFinal = indiceInicial + ITEMS_PER_PAGE;
  const ordensDaPaginaAtual = ordensServico.slice(indiceInicial, indiceFinal);
  
  return (
    <Layout className="min-height">
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        style={{ background: "#005A9E" }}
      >
        {loading ? (
          <></>
        ) : (
          <Menu
            defaultSelectedKeys={["1"]}
            mode="inline"
            style={{ background: "#005A9E" }}
            className={`custom-menu ${collapsed ? "menu-collapsed" : ""}`}
            onClick={({ key }) => {
              if (key === "analista-clear") {
                limparCampos(); // aqui chama a função que limpa tudo
                return;
              }

              if (key.startsWith("analista-")) {
                const analistaId = key.replace("analista-", "");
                setAnalistaSelecionado(analistaId);

                const ordensFiltradas = ordensServicoOriginais.filter(
                  (ordem) => ordem.analista?.id === analistaId
                );

                setOrdensServico(ordensFiltradas);
                //console.log("Ordens desse analista:", ordensFiltradas);
              }
            }}
            items={[
              {
                key: "1",
                icon: <PieChartOutlined />,
                label: "Dashboard",
              },
              {
                key: "analista-clear",
                icon: <ClearOutlined />,
                label: "Limpar filtro",
              },
              {
                key: "sub1",
                icon: <UserOutlined />,
                label: "Analistas",
                children: [
                  {
                    type: "group",
                    key: "analistas-search",
                    label: (
                      <>
                        <div style={{ display: "flex" }}>
                          {/**<div
                            className="icon-perfil"
                            onClick={() => setIsTrocarPerfilDeBusca(true)}
                          >
                            <AiOutlineUserSwitch />
                          </div> */}
                          <div>
                            <Input
                              placeholder="Buscar analista"
                              value={searchAnalista}
                              onChange={(e) => {
                                setSearchAnalista(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "group",
                    key: "analistas-scroll",
                    label: (
                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          scrollbarWidth: "thin", // Firefox
                          scrollbarColor: "transparent transparent", // Firefox
                        }}
                        className="scroll-transparent"
                      >
                        <Checkbox
                          checked={naoAtribuida}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setNaoAtribuida(checked);
                            setAnalistaSelecionado(null); // limpa o analista selecionado
                            setSearchAnalista(""); // limpa o campo de busca

                            if (checked) {
                              const ordensFiltradas =
                                ordensServicoOriginais.filter(
                                  (ordem) =>
                                    !ordem.analista || !ordem.analista.id
                                );
                              setOrdensServico(ordensFiltradas);
                            } else {
                              // Recarrega todas as ordens ou mantém as atuais, conforme sua lógica
                              setOrdensServico(ordensServicoOriginais);
                            }
                          }}
                          style={{ color: collapsed ? "black" : "#fff" }}
                        >
                          Não atribuído
                        </Checkbox>

                        {analistasMenuItems.map((item) => (
                          <div
                            key={item.key}
                            onClick={() => {
                              setNaoAtribuida(false);

                              const analistaId = item.key.replace(
                                "analista-",
                                ""
                              );
                              setAnalistaSelecionado(analistaId);
                              setSearchAnalista(item.label); // <-- seta o valor do Search com o nome do analista

                              const ordensFiltradas =
                                ordensServicoOriginais.filter(
                                  (ordem) => ordem.analista?.id === analistaId
                                );
                              setOrdensServico(ordensFiltradas);
                            }}
                            className={`select-analista ${
                              collapsed ? "black" : ""
                            }`}
                          >
                            {item.label}
                          </div>
                        ))}
                      </div>
                    ),
                  },
                ],
              },
              {
                key: "sub2",
                icon: <FilterOutlined />,
                label: "Filtro",
                children: [
                  {
                    type: "group",
                    label: (
                      <>
                        <div style={{ marginBottom: 8 }}>
                          <Input
                            placeholder="ID do cliente"
                            style={{ width: 150, fontSize: 12 }}
                            value={idCliente}
                            onChange={(e) => setIdCliente(e.target.value)}
                            allowClear
                          />
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Input
                            placeholder="OS"
                            style={{ width: 150, fontSize: 12 }}
                            value={ordemServico}
                            onChange={(e) => setOrdemServico(e.target.value)}
                            allowClear
                          />
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Select
                            mode="multiple"
                            allowClear
                            style={{ width: 150, fontSize: 12 }}
                            placeholder="Situação OS"
                            defaultValue={situacaoOS}
                            value={situacaoOS}
                            onChange={(value) => setSituacaoOS(value)}
                            options={[
                              { value: "Inicial", label: "Inicial" },
                              {
                                value: "Inicial em Negociação",
                                label: "Inicial em Negociação",
                              },
                              {
                                value: "Viabilidade Prefeitura",
                                label: "Viabilidade Prefeitura",
                              },
                              {
                                value: "Processo Concluído",
                                label: "Processo Concluído",
                              },
                              {
                                value:
                                  "Solicitada em Negociação / Aguardando Pagamento",
                                label:
                                  "Solicitada em Negociação / Aguardando Pagamento",
                              },
                              {
                                value: "Solicitada / Aguardando Pagamento",
                                label: "Solicitada / Aguardando Pagamento",
                              },
                              {
                                value: "Pagamento Identificado",
                                label: "Pagamento Identificado",
                              },
                              {
                                value: "Análise Junta Comercial",
                                label: "Análise Junta Comercial",
                              },
                              {
                                value: "Disponibilização de Documentos",
                                label: "Disponibilização de Documentos",
                              },
                              {
                                value: "Migração de Tipo de Empresa",
                                label: "Migração de Tipo de Empresa",
                              },
                              {
                                value: "Análise Receita Federal",
                                label: "Análise Receita Federal",
                              },
                              {
                                value: "Verificação de Emissor de NF",
                                label: "Verificação de Emissor de NF",
                              },
                              {
                                value: "Pendente Documentação",
                                label: "Pendente Documentação",
                              },
                              {
                                value: "Elaboração Junta Comercial",
                                label: "Elaboração Junta Comercial",
                              },
                              {
                                value: "Verificação de Documentos",
                                label: "Verificação de Documentos",
                              },
                              {
                                value: "Verificação Sindicato de Classe",
                                label: "Verificação Sindicato de Classe",
                              },
                              {
                                value: "Empresa Constituída / Aberta",
                                label: "Empresa Constituída / Aberta",
                              },
                              {
                                value: "Verificação de Débitos",
                                label: "Verificação de Débitos",
                              },
                              {
                                value: "Análise Prefeitura",
                                label: "Análise Prefeitura",
                              },
                              {
                                value: "Elaboração Prefeitura",
                                label: "Elaboração Prefeitura",
                              },
                              {
                                value: "Elaboração Prefeitura",
                                label: "Elaboração Prefeitura",
                              },
                              {
                                value: "disabled",
                                label: "Selecionar",
                                disabled: true,
                              },
                            ]}
                          />
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Select
                            mode="multiple"
                            allowClear
                            style={{ width: 150, fontSize: 12 }}
                            placeholder="Tipo de OS"
                            defaultValue={tipoOS}
                            value={tipoOS}
                            onChange={(value) => setTipoOS(value)}
                            options={[
                              {
                                value: "Alteração de Enquadramento (Migração)",
                                label: "Alteração de Enquadramento (Migração)",
                              },
                              {
                                value: "Abertura de Empresa",
                                label: "Abertura de Empresa",
                              },
                              {
                                value: "Baixa / Encerramento de Empresa",
                                label: "Baixa / Encerramento de Empresa",
                              },
                              {
                                value: "Alteração Contratual de Empresa",
                                label: "Alteração Contratual de Empresa",
                              },
                              {
                                value: "Serviços Avulsos Paralegal",
                                label: "Serviços Avulsos Paralegal",
                              },
                            ]}
                          />
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <RangePicker
                            style={{ width: 150, fontSize: 12 }}
                            value={dataCriacaoRange}
                            onChange={(val) => setDataCriacaoRange(val)}
                            format="DD/MM/YYYY"
                            placeholder={["Do dia", "Até"]}
                          />
                        </div>
                        <div style={{ marginBottom: 8 }}>
                          <Select
                            value={filtroDias}
                            onChange={(value) => setFiltroDias(value)}
                            style={{ width: 150, marginBottom: 16 }}
                          >
                            <option value="todos">Todos</option>
                            <option value="maiorIgual3">Com até 3 dias</option>
                            <option value="maiorIgual4">
                              Com 4 ou mais dias
                            </option>
                          </Select>
                        </div>

                        <div>
                          <Checkbox
                            checked={ordensAtivas}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setOrdensAtivas(checked);
                              if (checked) {
                                setSituacaoOSSuspensas(false);
                                setSituacaoOsCanceladas(false);
                                setSituacaoOsCanceladasESuspensa(false);
                                setSituacaoOsFinalizadaParalegal(false);
                                setOrdensAtivasParalegal(false);
                              }
                            }}
                          >
                            Ativas
                          </Checkbox>

                          <Checkbox
                            checked={ordensAtivasParalegal}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setOrdensAtivasParalegal(checked);
                              if (checked) {
                                setOrdensAtivas(false);
                                setSituacaoOSSuspensas(false);
                                setSituacaoOsCanceladas(false);
                                setSituacaoOsCanceladasESuspensa(false);
                                setSituacaoOsFinalizadaParalegal(false);
                              }
                            }}
                          >
                            Ativas Paralegal
                          </Checkbox>

                          <Checkbox
                            checked={situacaoOSSuspensas}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSituacaoOSSuspensas(checked);
                              if (checked) {
                                setOrdensAtivas(false);
                                setSituacaoOsCanceladas(false);
                                setSituacaoOsCanceladasESuspensa(false);
                                setSituacaoOsFinalizadaParalegal(false);
                                setOrdensAtivasParalegal(false);
                              }
                            }}
                          >
                            Suspensas
                          </Checkbox>

                          <Checkbox
                            checked={situacaoOsCanceladas}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSituacaoOsCanceladas(checked);
                              if (checked) {
                                setOrdensAtivas(false);
                                setSituacaoOSSuspensas(false);
                                setSituacaoOsCanceladasESuspensa(false);
                                setSituacaoOsFinalizadaParalegal(false);
                                setOrdensAtivasParalegal(false);
                              }
                            }}
                          >
                            Canceladas
                          </Checkbox>

                          <Checkbox
                            checked={situacaoOsCanceladasESuspensa}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSituacaoOsCanceladasESuspensa(checked);
                              if (checked) {
                                setOrdensAtivas(false);
                                setSituacaoOSSuspensas(false);
                                setSituacaoOsCanceladas(false);
                                setSituacaoOsFinalizadaParalegal(false);
                                setOrdensAtivasParalegal(false);
                              }
                            }}
                          >
                            Canceladas e Suspensa
                          </Checkbox>

                          <Tooltip
                            title="⚠ Atenção: chegar nessa situação não significa que a OS esteja com o processo concluído. Para o Paralegal, indica apenas que ela está finalizada para este departamento."
                          >
                            <Checkbox
                              checked={situacaoOsFinalizadaParalegal}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSituacaoOsFinalizadaParalegal(checked);
                                if (checked) {
                                  setOrdensAtivas(false);
                                  setSituacaoOSSuspensas(false);
                                  setSituacaoOsCanceladas(false);
                                  setOrdensAtivasParalegal(false);
                                }
                              }}
                            >
                              Finalizadas Paralegal
                            </Checkbox>
                          </Tooltip>

                        </div>
                      </>
                    ),
                  },
                ],
              },
            ]}
          />
        )}
      </Sider>
      <Layout>
        <Header className="header-style" />
        <Content className="margin-0-16">

          {/*aqui é os cards de resultados*/}
          <ResultCards
            loading={loading}
            mudarNome={mudarNome}
            ativas={ativas}
            suspenca={suspenca}
            finalizadas={finalizadas}
            canceladas={canceladas}
            total={total}
            situacaoOsFinalizadaParalegal={situacaoOsFinalizadaParalegal}
            setIsExportExcel={setIsExportExcel}
            setIsModalOsPorEstados={setIsModalOsPorEstados}
            carregarLote={()=> setModalVisible(true)}
          />




          <div className="display-flex">
            <div className="">
              <div style={{width: "100%"}}>
                <TabelaOrdensServico
                  nomeAnalista={nomeAnalista}
                  setNomeAnalista={setNomeAnalista}
                  loading={loading}
                  paginatedData={ordensDaPaginaAtual}
                  setIdSelecionado={setIdSelecionado}
                  setIsModalPortalContadorOS={setIsModalPortalContadorOS}
                  formatarObservacoes={formatarObservacoes}
                  setObservacoesAtuais={setObservacoesAtuais}
                  setIsMostrarObservacao={setIsMostrarObservacao}
                  ultimaDataObservacao={ultimaDataObservacao}
                  diasDesdeUltimaObservacao={diasDesdeUltimaObservacao}
                  analistasUnicos={analistasUnicos}
                />


                <ModalObservacao
                  isMostrarObservacao={isMostrarObservacao}
                  handleCancel={() => setIsMostrarObservacao(false)}
                  observacoesAtuais={observacoesAtuais}
                />


                {isExportExcel && (
                  <ExportExcel
                    isExportExcel={isExportExcel}
                    setIsExportExcel={setIsExportExcel}
                    data={ordensServico}
                  />
                )}

                {/* --- Paginação --- */}
                {!loading && ordensServico.length > 0 && (
                  <div className="pagination-container">
                    <button
                      className="pagination-button"
                      disabled={paginaAtual === 1}
                      onClick={() => setPaginaAtual((p) => p - 1)}
                    >
                      <GrFormPrevious />
                    </button>

                    <span className="pagination-info">
                      {paginaAtual} / {totalPaginas ?? Math.max(1, Math.ceil(ordensServico.length / ITEMS_PER_PAGE))}
                    </span>

                    <button
                      className="pagination-button"
                      disabled={paginaAtual >= (totalPaginas ?? Math.ceil(ordensServico.length / ITEMS_PER_PAGE))}
                      onClick={() => setPaginaAtual((p) => p + 1)}
                    >
                      <MdNavigateNext />
                    </button>
                  </div>
                )}

               

                {/* Loading */}
                {loading && ordensServico.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 20 }}>
                    <CircularProgress />
                    <p>Carregando...</p>
                  </div>
                )}


              </div>
            </div>

            {/**<div className="box-sh-grafico">
              {loading ? (
                <></>
              ) : (
                <DoughnutChart
                  canceladas={canceladas}
                  finalizadas={finalizadas}
                  suspenca={suspenca}
                  ativas={ativas}
                />
              )}
            </div> */}
          </div>

        </Content>
        <Footer style={{ textAlign: "center" }}>
          Dashboard ©{new Date().getFullYear()} Criado pela equipe de
          Desenvolvimento do Meu Contador Online
        </Footer>

        {/* ---- Modal inicial ---- */}
        <Modal
          title="Configuração de carregamento"
          open={modalVisible}
          onOk={confirmarCarregamento}
          onCancel={() => setModalVisible(false)}
          okText="Confirmar"
          cancelText="Cancelar"
          width={"45%"}
        >
          <div style={{display: "flex"}}>
            <div style={{ marginBottom: 12, marginRight: 10, width: "100%", color: "#616161" }}>
              <strong><p>Quantas ordens você quer na busca?</p></strong>
              <Select
                value={tamanhoLote}
                onChange={(value) => setTamanhoLote(value)}
                style={{ width: "100%" }}
              >
                 <Option value={500}>500</Option>
                <Option value={2000}>2.000</Option>
                <Option value={5000}>5.000</Option>
                <Option value={7000}>7.000</Option>
                <Option value={10000}>10.000</Option>
                <Option value={20000}>20.000</Option>
                <Option value={40000}>40.000</Option>
                <Option value={60000}>60.000</Option>
                <Option value={80000}>80.000 (⚠️ Por se tratar de muitos dados, essa opção pode demorar um pouco)</Option>
                <Option value={100000}>100.000 (⚠️ Por se tratar de muitos dados, essa opção pode demorar um pouco)</Option>
                <Option value={150000}>
                  150.000 (⚠️ Por se tratar de muitos dados, essa opção pode demorar um pouco)
                </Option>

              </Select>
            </div>

            <div style={{ marginBottom: 16, color: "#616161" }}>
              <strong><p>Perfil</p></strong>
              <Select
                value={perfilNome}
                onChange={(value) => setPerfilNome(value)}
                style={{ width: 100 }}
              >
                <Option value="TODOS">TODOS</Option>
                <Option value="PARALEGAL">Paralegal</Option>
                <Option value="CONTADOR">Contador</Option>
                <Option value="VENDAS">Vendas</Option>
              </Select>
            </div>
          </div>
        </Modal>

        <Modal
          title="OS por Estados brasileiros"
          open={isModalOsPorEstados}
          onCancel={() => setIsModalOsPorEstados(false)}
          cancelText="Fechar"
          width="800px"
          footer={null}
        >
          <div style={{ height: "400px" }}>
            <DoughnutBar ordensUFAtivas={ordensUFAtivas} />
          </div>
        </Modal>

        <Modal 
          open={isModalPortalContadorOS} 
          width={"95%"} 
          onCancel={() => setIsModalPortalContadorOS(false)}
          footer={null}
        >
          <PortalContadorOS
            numeroSolicitacao={idSelecionado}
            setIsModalPortalContadorOS={() => setIsModalPortalContadorOS(false)}
            isModalPortalContadorOS={isModalPortalContadorOS}
          />
        </Modal>
 
      </Layout>
    </Layout>
  );
  
}

export default DashboardOrdemServico;
